import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles((theme) =>
  createStyles({
    cell: {
      overflow: 'visible',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      textAlign: 'center',
      // Поскольку onClick на всей ячейки, то при наведении на ячейку выделяем чекбокс
      '&:hover:not($disabled)': {
        cursor: 'pointer',
        '& $checkbox': {
          color: '#333',
          backgroundColor: 'rgba(16, 156, 241, 0.04)',
        },
        '& $checkbox.Mui-checked': {
          color: theme.palette.primary.main,
          backgroundColor: 'rgba(16, 156, 241, 0.04)',
        },
      },
    },
    disabled: {
      cursor: 'default',
      '& $checkbox': {
        cursor: 'default',
      },
    },
    checkbox: {
      marginTop: '-1px',
      marginBottom: '-1px',
      padding: theme.spacing(1),
    },
  })
);
